<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2022-01-30 00:09:16
 * @LastEditTime: 2025-10-13 10:28:13
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <main class="page-wrapper">
    <Header v-if="showHeader" :data="$props" />
    <div class="main-content active-light-mode">
      <slot></slot>
    </div>
    <Footer :data="$props" />
  </main>
</template>

<script>
import Header from "./header/Header";
import Footer from "./footer/Footer";

export default {
  name: "Layout",
  components: { Header, Footer },
  props: {
    logo: {
      type: String,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showTopHeader: {
      type: Boolean,
      default: false,
    },
    topbarStyle: {
      type: Number,
      default: 1,
    },
    showThemeSwitcherButton: {
      type: Boolean,
      default: false,
    },
    headerTransparency: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: "header-left-align",
    },
    navAlignment: {
      type: String,
      default: "left",
    },
    contactButtonClass: {
      type: String,
      default: "btn-contact",
    },
    footerStyle: {
      type: Number,
      default: 1, // 1.中文版 2.英文日文
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    showCopyright: {
      type: Boolean,
      default: true,
    },
    showNewsletter: {
      type: Boolean,
      default: false,
    },
    showCta: {
      type: Boolean,
      default: true,
    },
  },
};
</script>